<template>
  <v-sheet>
    <v-autocomplete
      single-line
      :items="sections"
      data-vv-name="section"
      v-validate="'required'"
      v-model="value.section"
      :data-vv-as="$t('section')"
      :placeholder="$t('section')"
      :error-messages="errors.collect('section')"
    />
    <v-textarea
      rows="1"
      auto-grow
      single-line
      v-validate="'required'"
      data-vv-name="question"
      v-model="value.details"
      :data-vv-as="$t('question')"
      :placeholder="$t('question')"
      :error-messages="errors.collect('question')"
    />
    <v-textarea
      rows="1"
      auto-grow
      single-line
      v-model="value.mr_0"
      :placeholder="$t('mr_0')"
    />
    <v-textarea
      rows="1"
      auto-grow
      single-line
      v-model="value.mr_1"
      :placeholder="$t('mr_1')"
    />
    <v-textarea
      rows="1"
      auto-grow
      single-line
      v-model="value.mr_2"
      :placeholder="$t('mr_2')"
    />
    <v-textarea
      rows="1"
      auto-grow
      single-line
      v-model="value.mr_3"
      :placeholder="$t('mr_3')"
    />
    <v-textarea
      rows="1"
      auto-grow
      single-line
      v-model="value.mr_4"
      :placeholder="$t('mr_4')"
    />
    <v-textarea
      rows="1"
      auto-grow
      single-line
      v-model="value.mr_5"
      :placeholder="$t('mr_5')"
    />
    <v-flex xs12 class="flex-row ">
      <v-checkbox
        color="teal"
        :label="$t('compulsory')"
        v-model="value.compulsory"
      />
      <v-checkbox
        color="teal"
        :label="$t('pro_rated')"
        v-model="value.pro_rated"
      />
    </v-flex>

    <div class="my-2 di-flex justify-end">
      <v-btn color="btn_color secondary" :loading="loading" @click="save">
        {{ $t("save") }}
      </v-btn>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: ["value"],
  name: "questionForm",

  data: () => ({
    loading: false,
    sections: [
      { text: "Internal Governance and Strategic Management", value: 1 },
      { text: "Project Management and Program Delivery", value: 2 },
      { text: "Financial Management", value: 3 },
      { text: "Human Resources", value: 4 },
      { text: "External Relations, Communications and Outreach", value: 5 }
    ]
  }),

  methods: {
    save() {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) {
          this.axios
            .post("questions", this.value)
            .then(res => {
              this.loading = false;
              this.$store.commit("showSnackbar", {
                text: this.$t("save_succeed"),
                stateType: "success",
                show: true
              });
              this.$validator.reset();
              this.$emit("saved", res.data.data);
            })
            .catch(() => (this.loading = false));
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
        }
      });
    }
  }
};
</script>
